import { deleteFromReportListByReportId } from '../store/slices/reportSlice';
import { useAppDispatch } from '../store/configureStore';

const handleReportDeletion = async (id) => {
  const dispatch = useAppDispatch();
  dispatch(deleteFromReportListByReportId(id));
};

export default handleReportDeletion;
